import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Polyfill for import.meta if needed
if (typeof import.meta === 'undefined') {
  window.import = window.import || {};
  window.import.meta = window.import.meta || {};
  window.import.meta.env = process.env;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);